module.exports = __webpack_public_path__ + "static/media/chat.b536e9ac.png";